import Text from 'components/base/Text';
import _ from 'lodash';
import SensorDescription from './SensorDescription';
import SensorCTA from './SensorCTA';
import { SENSOR_NAMES } from '@linearb/linjs-common';
import { isAdmin } from 'common/services/accounts.service';

const NOTIFICATIONS_SENSORS = [SENSOR_NAMES.MS_TEAMS, SENSOR_NAMES.SLACK];
const DATA_SENSORS = [
  SENSOR_NAMES.CLUBHOUSE,
  SENSOR_NAMES.AZURE_DEVOPS,
  SENSOR_NAMES.GITLAB,
  SENSOR_NAMES.GITHUB,
  SENSOR_NAMES.JIRA,
  SENSOR_NAMES.BITBUCKET_SERVER,
  SENSOR_NAMES.BITBUCKET,
  SENSOR_NAMES.AZURE_BOARDS
];

export const getNotificationsSensors = (sensorAuthorizations = []) =>
  sensorAuthorizations?.filter(sensor =>
    NOTIFICATIONS_SENSORS.includes(sensor?.sensor_name)
  );

export const getDataSensors = sensorAuthorizations =>
  sensorAuthorizations?.filter(sensor =>
    DATA_SENSORS.includes(sensor?.sensor_name)
  );

export const getCanReauth = (sensorAuthorization, account) =>
  account &&
  sensorAuthorization &&
  !sensorAuthorization.is_multi_token_enabled &&
  (isAdmin(account) || account.id === sensorAuthorization.account_id);

export const getTableConfig = () => {
  return [
    {
      name: 'SERVICE',
      dataPoint: 'name',
      tableCellProps: { style: { width: '25%' } }
    },
    {
      name: 'FAILURE REASON',
      dataPoint: 'failing_reason',
      tableCellProps: { style: { width: '75%' } }
    },
    {
      name: 'ACTIONS',
      dataPoint: 'call_to_action'
    }
  ];
};

const getSensorFailingReason = sensorAuthorization => {
  let failingReason = _.get(
    sensorAuthorization,
    'failing_reason.description',
    ''
  );
  try {
    failingReason = decodeURIComponent(failingReason);
  } catch (err) {}
  return (
    <Text size='large' weight='400' multiLineEllipsisAfter={10}>
      {failingReason || 'N/A'}
    </Text>
  );
};

export const getSensorsTableData = ({
  failingSensorsAuthorizations,
  rateLimitSensorsAuthorizations
}) => {
  const failingTableData = failingSensorsAuthorizations.map(
    sensorAuthorization => {
      return {
        name: <SensorDescription sensorAuthorization={sensorAuthorization} />,
        failing_reason: getSensorFailingReason(sensorAuthorization),
        call_to_action: <SensorCTA sensorAuthorization={sensorAuthorization} />
      };
    }
  );

  const rateLimitTableData = rateLimitSensorsAuthorizations.map(
    rateLimitSensor => {
      return {
        name: rateLimitSensor.notification.title,
        failing_reason: (
          <Text size='large' weight='400' multiLineEllipsisAfter={10}>
            {rateLimitSensor.notification.description}
          </Text>
        ),
        call_to_action: rateLimitSensor.notification.cta
      };
    }
  );

  return [...failingTableData, ...rateLimitTableData];
};
